module.exports = __webpack_public_path__ + "use-cases-3-f25b81faf0e6f171f1340294b2b4ea9d.webp";